export const featureFlagV2Keys = {
    isEnabled: (flagKey, subdomain) => ['featureFlagV2', 'isEnabled', flagKey, subdomain],
};
